import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';

function LinkWrapper({ children, href, disable, style, isExternal, onClick = () => {} }) {
    const history = useHistory();

    const handleClick = () => {
        if (disable) return;
        if (typeof onClick === 'function') {
            onClick();
        }
        if (typeof href === 'string' && Boolean(href)) {
            history.push(href);
        }
    };

    return isExternal ? (
        <div css={[linkStyle, disable && disableStyle, style]} onClick={handleClick}>
            {children}
        </div>
    ) : (
        <Link css={linkStyle} to={href} onClick={onClick}>
            {children}
        </Link>
    );
}

LinkWrapper.propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    disable: PropTypes.bool,
    style: PropTypes.object,
    isExternal: PropTypes.bool,
    onClick: PropTypes.func
};

export default LinkWrapper;

const linkStyle = css`
    cursor: pointer;
    text-decoration: none;
`;

const disableStyle = css`
    cursor: initial;
`;
